/**
 * @file: 货架复制粘贴时处理层板链接属性
 * @author: xiong.zhou@dmall.com
 */

import * as Toolkit from '../../toolkit/index';
import * as CubeTree from '../../cubeTree/index';
import CodiSystem from '../../codiSystem/index';
import { __getLinks__, __replaceAll__ } from './db';
import { validate, updateTargetLayerGroupStatus } from './groupStatus';
import { createLink, layerLink, getGroupList } from './link';

/**
 * @description: 粘贴货架并对原层板分组进行链接
 * @param {Array} addCubeIds 粘贴完成后生成的cubeId数组
 * @param {Array} copyData 粘贴数据
 * @return {*} void
 */
function groupPasteShelf(addCubeIds: Array<CubeId>, copyData:FreeObjMap): void {
    const { linkIndexList } = copyData.extendParams;

    linkIndexList.forEach((indexList: Array<FreeObjMap>) => {
        const newLinkList: CubeId[] = [];
        // 将粘贴生成的货架中复制前存在链接关系的层板分组(根据层板在原货架中的索引位置进行判断)
        indexList.forEach((indexInfo: FreeObjMap) => {
            const shelfCube = CubeTree.findByCubeId(addCubeIds[indexInfo.groupIndex]);
            const linkLayerId = CubeTree.findChildCubeByIndex(shelfCube.id,indexInfo.layerIndex);
            
            linkLayerId && newLinkList.push(linkLayerId);
        })

        // 对复制出来的层板分组进行链接操作
        if (newLinkList.length) {
            let checkResult: ValidateResult = validate(newLinkList);

            if (checkResult.code !== 0) {
                return;
            }
            let sortIds: CubeId[] = CodiSystem.sortByLeft(newLinkList);
            let link: LinkedListInstance = createLink(sortIds);
            let oldLinks: LinkedListInstance[] = __getLinks__();

            Toolkit.linkGroupAdd(oldLinks, link);
            __replaceAll__(oldLinks);

            let layersLink: LinkedListInstance|null = layerLink(sortIds[0]);

            if (layersLink) {
                updateTargetLayerGroupStatus(layersLink);
            }
        }
    })
}

/**
 * @description: 通过当前图纸所有层板链接从复制数据中找到复制数据中的链接索引
 * 当后续粘贴生成新的货架数据时，根据索引从新的货架数据中得到包含cubeId的真实链接编组
 * @param {Array} copyedIds
 * @return {Array} linkIndexList 链接索引值
 */
function getLinkIndexListFromCopy(copyedIds: Array<CubeId>) {
    const linkIndexList:Array<FreeObjMap> = [];
    const groupLinkList:CubeId[][] = getGroupList();

    groupLinkList.forEach((linkList: CubeId[]) => {
        // 将粘贴生成的货架中复制前存在链接关系的层板分组(根据层板在原货架中的索引位置进行判断)
        const itemLinkIndexList:Array<FreeObjMap> = []

        linkList.forEach((layerId: CubeId) => {
            const groupIndex: number = copyedIds.findIndex((copyId: CubeId) => {
                return copyId === CubeTree.findParentIdByCubeId(layerId);
            })
            let layerIndex: number = -1;

            if (groupIndex !== -1) {
                layerIndex = CubeTree.getCubeIndex(layerId);
                if (layerIndex !== -1) itemLinkIndexList.push({groupIndex,layerIndex})
            }
        })

        itemLinkIndexList.length && linkIndexList.push(itemLinkIndexList)
    })

    return linkIndexList
}

export {
    groupPasteShelf,
    getLinkIndexListFromCopy
};
